import { RoutingModule, RoutingModuleV2 } from 'modules/api';
import { apiClient } from 'modules/apiClient';

const downloadRoutingCsv = async (
  routingId: number | string,
): Promise<{
  blob: Blob;
  contentDisposition: string;
}> => {
  const response = await apiClient.get(
    `${RoutingModule.Base}/${routingId}/csv`,
    {
      responseType: 'blob',
    },
  );
  return {
    blob: response.data,
    contentDisposition: response.headers['content-disposition'],
  };
};

const downloadRoutingCsvV2 = async (
  routingId: number | string,
): Promise<{
  blob: Blob;
  contentDisposition: string;
}> => {
  const response = await apiClient.get(
    `${RoutingModuleV2.Base}/${routingId}/csv`,
    {
      responseType: 'blob',
    },
  );
  return {
    blob: response.data,
    contentDisposition: response.headers['content-disposition'],
  };
};

export const RoutingFilesApi = {
  downloadRoutingCsv,
  downloadRoutingCsvV2,
};
